import { createContext } from "react";

const StuntDriversContext = createContext();
StuntDriversContext.displayName = "StuntDriversContext";

export const StuntDriversProvider = StuntDriversContext.Provider;
export const StuntDriversConsumer = StuntDriversContext.Consumer;

export default StuntDriversContext;
